import React from 'react';
import styled from 'styled-components';
import { SiFigma, SiHtml5, SiVisualstudiocode, SiMui } from 'react-icons/si';
import { DiDotnet, DiPostgresql, DiReact } from 'react-icons/di';
import { BiLogoTypescript } from 'react-icons/bi';

const Container = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 2rem;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const ContainerFlex = styled.span`
    display: inline-flex;
    flex-direction: row;
    gap: 1.5rem;
    width: max-content;
    padding: 0 calc(2rem + 1vw);
    font-size: clamp(1.5rem, 2vw, 2.25rem);
`;

const StackSigma = () => {
    return (
        <Container className='exp'>
            <ContainerFlex>
                <SiFigma size={'1em'} />
                <SiHtml5 size={'1em'} />
                <SiMui size={'1em'} />
                <DiDotnet size={'1em'} />
                <BiLogoTypescript size={'1em'} />
                <DiPostgresql size={'1em'} />
                <DiReact size={'1em'} />
                <SiVisualstudiocode size={'1em'} />
            </ContainerFlex>
        </Container>
    );
};

export default StackSigma;
